<div class="bcg p-4 ">
  <div class="" style="display: flex; justify-content:space-between;align-items:center;">
    <div class="">
      <div class="d-flex justify-content-between custom-container">
        <nav class="custom-nav">
          <ol class="breadcrumb">
            <li *ngIf="userRole === 'CLIENT'; else showAdminDashboard" class="breadcrumb-item" style="cursor: pointer;"
              [routerLink]="'/doqfy/dashboard'">Dashboard</li>
            <ng-template #showAdminDashboard>
              <li class="breadcrumb-item" style="cursor: pointer;" [routerLink]="'/doqfy/admin-dashboard'">Dashboard
              </li>
            </ng-template>
            <li class="breadcrumb-item active" style="cursor: context-menu;" aria-current="page">E-stamp</li>
          </ol>
        </nav>
      </div>
    </div>

  </div>

  <div *ngIf="showEstampDetails" class="card card_outLine mt-3">
    <div class="card-body">
      <div class="row">
        <div class="col-lg-6 col-sm-6 col-md-6">
          <h5 class="title_five">E-Stamp</h5>
          <p class="card-text text_p ">e-Stamp documents on the Cloud</p>
        </div>
        <div class="col-lg-6 col-sm-6 col-md-6 text-right custom_button">
          <p-button label="Article Code List" (click)="getArticleCode(articleList)"
            styleClass="p-button-sm-outline me-2"></p-button>

          <p-button label="Back" (click)="back()" styleClass="p-button-sm"></p-button>
        </div>
      </div>
    </div>
  </div>
  <div class="card m-4 card_style_bs_order_cat card_outLine">
    <div class="card-body " style="padding-bottom: 0;">
      <span class="title_five">Finish Setting Up in Two Simple Steps</span>
      <ul class="steps_style " style="padding-left: 0;">
        <li [ngClass]="[active_eStamp ? 'box-item_active' : '', showEstampDetails ? 'boxOutline' : 'box-item']"
          class="col-lg-2 col-md-2 col-sm-3 col-4  clickable" (click)="showEstampDetails ? gotToCatEditScreen('estamp') : null">1. E-stamp details
        </li>
        <li [ngClass]="[active_confirm ? 'box-item_active' : '', showConfirmation ? 'boxOutline' : 'box-item']"
          class="col-lg-2 col-md-2 col-sm-3 col-4  clickable">2. Order
          confirmation</li>
      </ul>
    </div>
  </div>

  <div *ngIf="!showConfirmation" class="text-right m-2 blk-txt">
    <p class="text_p">Try <a [routerLink]="['/doqfy/bulk-upload/form', 'e-stamp']" class="btn-link clickable link_text" trackClick="click_bulk_upload_estamp">
        Bulk Upload </a>if you have more than 5 E-stamp details (or) E-sign.
  </div>
  <div *ngIf="showEstampDetails">
    <app-estamp-details [estampData]="estampData" (estampChange)="onestampDataChange($event)"></app-estamp-details>
  </div>
  <div *ngIf="showConfirmation">
    <app-order-confirmation-details #orderDetails [orderConfirmationData]="orderConfirmationData"
      (orderConfirmationChange)="onOrderConfirmationChange($event)"></app-order-confirmation-details>
  </div>

</div>

<p-confirmDialog [style]="{width: '50vw'}" (onAccept)="onApproveMethod()"></p-confirmDialog>


<ng-template #reviewOrder let-modal>
  <div class="modal-header">
    <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeModel()" aria-label="Close"></button>
  </div>
  <div class="modal-content">
    <div class="modal-body">
      <app-review-order-details [reviewOrderData]="reviewOrderData"
        (reviewOrderDataChange)="reviewOrderDataChange($event)"></app-review-order-details>
    </div>
  </div>
</ng-template>


<ng-template #articleList let-modal>
  <div class="modal-header">
    <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeModel()" aria-label="Close"></button>
  </div>
  <app-article-code-list></app-article-code-list>

</ng-template>

<div class="toast_display_layer">
  <p-toast></p-toast>
</div>


<ng-template #paymentScreen let-modal>
<div class="modal-header">
  <strong *ngIf="paymentDetails.paymentMethod==='razorpay' || paymentDetails.paymentMethod==='HDFC_GATEWAY'">Payment Details</strong>
  <strong *ngIf="paymentDetails.paymentMethod==='wallet'">Payment Details (Wallet)</strong>
  <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeModel()" aria-label="Close"></button>
</div>
<div class="modal-content">
  <div class="modal-body">
  <app-payment-order [paymentOrderData]="paymentOrderData"
  (paymentOrderDataChange)="paymentOrderDataChange($event)"></app-payment-order>
  </div>
</div>
</ng-template>